document.addEventListener('DOMContentLoaded', function () {
  const openBtns = document.querySelectorAll('[data-zip-open]');
  const closeBtns = document.querySelectorAll('[data-zip-close]');
  const zipInputs = document.querySelectorAll('[data-zip-input]');
  const saveBtns = document.querySelectorAll('[data-zip-save]');
  const zipMsgs = document.querySelectorAll('[data-zip-message]');

  function isUSZip(zip) {
    return /^[0-9]{5}$/.test(zip);
  }

  function getRegionByZip(zip) {
    const firstDigit = zip.charAt(0);

    if (['4', '5', '6'].includes(firstDigit)) return 'north';
    if (['8', '9'].includes(firstDigit)) return 'west';
    if (['0', '1', '2'].includes(firstDigit)) return 'east';
    if (['3', '7'].includes(firstDigit)) return 'south';

    return null;
  }

  function formatDate(date) {
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric'
    });
  }

  function getNextBusinessDay(date, daysToAdd) {
    const result = new Date(date);
    let added = 0;

    while (added < daysToAdd) {
      result.setDate(result.getDate() + 1);
      const day = result.getDay();
      if (day !== 0 && day !== 6) { // skip Sunday (0) and Saturday (6)
        added++;
      }
    }

    return result;
  }

  function getETA(zip) {
    if (!isUSZip(zip)) {
      return {
        available: false,
        dateRange: '',
        message: 'Delivery is not available for this ZIP code.'
      };
    }

    const region = getRegionByZip(zip);

    if (!region) {
      return {
        available: false,
        dateRange: '',
        message: 'Delivery is not available for this ZIP code.'
      };
    }

    const today = new Date();

    // Start = next business day from today
    const startDate = getNextBusinessDay(today, 1);
    // End = 2 business days after start
    const endDate = getNextBusinessDay(startDate, 2);

    const dateRange = formatDate(startDate) + ' to ' + formatDate(endDate);

    return {
      available: true,
      region: region,
      dateRange: dateRange,
      message: 'Expected Delivery Date ' + dateRange
    };
  }

  function updateZipLabels(zip) {
    document.querySelectorAll('[data-zip-label]').forEach(function (label) {
      label.textContent = zip;
    });

    zipInputs.forEach(function (input) {
      input.value = zip;
    });
  }

  function setZipMessages(message) {
    zipMsgs.forEach(function (msg) {
      msg.textContent = message;
    });
  }

  function updateETA(zip) {
    const eta = getETA(zip);

    document.querySelectorAll('[data-product-eta]').forEach(function (box) {
      box.style.display = 'block';

      if (eta.available) {
        const dateRangeEl = box.querySelector('.eta-date-range');

        if (dateRangeEl) {
          dateRangeEl.textContent = eta.dateRange;
        } else {
          box.innerHTML = `
            <div class="eta-available">
              <strong>Expected Delivery Date</strong> ${eta.dateRange}
            </div>
          `;
        }
      } else {
        box.innerHTML = `
          <div class="eta-unavailable">
            <strong>${eta.message}</strong>
          </div>
        `;
      }
    });

    updateZipLabels(zip);
    setZipMessages(eta.message);
  }

  function unlockBodyScroll() {
    document.body.classList.remove('overflow-hidden-tablet');
    document.body.classList.remove('overflow-hidden-desktop');
    document.body.classList.remove('overflow-hidden-mobile');
    document.body.classList.remove('overflow-hidden');
    document.body.style.overflow = '';
  }

  function closeAllPopups() {
    document.querySelectorAll('[data-zip-popup]').forEach(function (popup) {
      popup.classList.remove('active');
    });
    unlockBodyScroll();
  }

  const savedZip = localStorage.getItem('customer_zip_code');

  if (savedZip) {
    updateETA(savedZip);
  }

  openBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const wrapper = btn.closest('[data-zip-wrapper]');
      const popup = wrapper
        ? wrapper.querySelector('[data-zip-popup]')
        : document.querySelector('[data-zip-popup]');

      if (popup) {
        popup.classList.add('active');
      }
    });
  });

  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();

      const popup = btn.closest('[data-zip-popup]');

      if (popup) {
        popup.classList.remove('active');
        unlockBodyScroll();
      }
    });
  });

  saveBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();

      const wrapper = btn.closest('[data-zip-wrapper]') || document;
      const input = wrapper.querySelector('[data-zip-input]');

      if (!input) return;

      const zip = input.value.trim();

      if (!zip) {
        setZipMessages('Please enter ZIP code.');
        return;
      }

      localStorage.setItem('customer_zip_code', zip);
      updateETA(zip);
      closeAllPopups();
    });
  });

  zipInputs.forEach(function (input) {
    input.addEventListener('keypress', function (e) {
      if (e.key === 'Enter') {
        const wrapper = input.closest('[data-zip-wrapper]') || document;
        const saveBtn = wrapper.querySelector('[data-zip-save]');

        if (saveBtn) {
          saveBtn.click();
        }
      }
    });
  });
});